"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProductSpecsFeaturesContainerItem;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _text = _interopRequireDefault(require("@ux/text"));
const RowContainer = /*#__PURE__*/(0, _react2.styled)("tr")({
  name: "RowContainer",
  class: "pl-r1e286j0"
});
const RowTitleContainer = /*#__PURE__*/(0, _react2.styled)("td")({
  name: "RowTitleContainer",
  class: "pl-rzyll94"
});
const RowDescriptionContainer = /*#__PURE__*/(0, _react2.styled)("td")({
  name: "RowDescriptionContainer",
  class: "pl-rwzxm4f"
});

/**
 * ProductSpecsFeaturesContainerItem Component
 *
 * @param {Object} props React props
 * @param {String} props.featuresTitle 2. Column Title
 * @param {String} props.featuresDescription 3.Column Description
 * @returns {React.ReactElement} Row Component
 * @public
 */
function ProductSpecsFeaturesContainerItem({
  featuresTitle,
  featuresDescription
}) {
  return /*#__PURE__*/_react.default.createElement(RowContainer, null, /*#__PURE__*/_react.default.createElement(RowTitleContainer, null, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title",
    size: 1,
    text: featuresTitle,
    "data-cy": "paragraph"
  })), /*#__PURE__*/_react.default.createElement(RowDescriptionContainer, null, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    size: -1,
    text: featuresDescription,
    "data-cy": "paragraph"
  })));
}
ProductSpecsFeaturesContainerItem.propTypes = {
  featuresTitle: _propTypes.default.string,
  featuresDescription: _propTypes.default.string
};